/* import __COLOCATED_TEMPLATE__ from './reset-password-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { object, string } from 'yup';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { validateSchema } from 'sh-www/utils/validators';

const RESET_PASSWORD_ORDER = ['email', 'generic-exception'];
const UPDATE_PASSWORD_ORDER = ['password', 'password_confirmation', 'generic-exception'];

class ResetPasswordForm extends Component {
  @tracked showUpdatePassword = this.args.showUpdatePassword ?? false;
  @tracked resetPasswordSuccess = false;

  @tracked email = this.args.email || '';
  @tracked password = '';
  @tracked password_confirmation = '';
  @tracked errors = { };
  @tracked errorStatus;

  get isLoading() {
    return this.resetPasswordTask.isRunning || this.updatePasswordTask.isRunning;
  }

  get genericException() {
    return this.errors['generic-exception']?.[0];
  }

  get genericExceptionOrEmail() {
    let error = this.genericException || this.errors['email']?.[0];

    if (error && !error.endsWith('.')) {
      error = error.concat('.');
    }

    return error;
  }

  get showRequestNew() {
    return this.errorStatus !== 403;
  }

  @action
  updateField(fieldName, value) {
    this[fieldName] = value;

    if (this.errors[fieldName] || this.genericException) {
      const { [fieldName]: _, ['generic-exception']: __, ...rest } = this.errors;
      this.errors = rest;
    }
  }

  @action
  requestNewLink(e) {
    e.preventDefault();
    this.errors = { };
    this.password = '';
    this.password_confirmation = '';
    this.showUpdatePassword = false;
  }

  @task
  *resetPasswordTask(e) {
    e.preventDefault();
    this.errors = { };

    const schema = object({
      email: string()
        .required('Please enter a valid email')
        .email('Please enter a valid email'),
    });

    const [values, errors] = validateSchema(this, schema);

    if (errors) {
      this.errors = errors;
      return;
    }

    try {
      yield this.args.onPasswordReset(values.email);
      this.resetPasswordSuccess = true;
    } catch (e) {
      handleErrorResponse(this, e, RESET_PASSWORD_ORDER, false);
    }
  }

  @task
  *updatePasswordTask(e) {
    e.preventDefault();
    this.errors = { };

    const schema = object({
      password: string().required('Password is a required field'),
      password_confirmation: string().when('password', ([password], schema) => {
        const msg = 'Passwords must match';

        return password
          ? schema.required(msg).oneOf([password], msg)
          : schema;
      }),
    });

    const [values, errors] = validateSchema(this, schema);

    if (errors) {
      this.errors = errors;
      return;
    }

    try {
      yield this.args.onPasswordUpdate(values.password, values.password_confirmation);
    } catch (e) {
      this.errorStatus = e.status;
      handleErrorResponse(this, e, UPDATE_PASSWORD_ORDER, false);
    }
  }
}

export default ResetPasswordForm;
